var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "upgrade" } },
    [
      _c("div", { staticClass: "bg" }),
      _c("c-header-return", {
        attrs: { isCustom: true },
        scopedSlots: _vm._u([
          {
            key: "customTitle",
            fn: function () {
              return [
                _c("div", { staticClass: "flex flex-ver" }, [
                  _c("p", { staticClass: "title-con-middle-title" }, [
                    _vm._v("欧皇升级"),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "title-con-middle flex flex-center-1",
                      on: {
                        click: function ($event) {
                          _vm.notice_modal_show = true
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticClass: "case-title-rule-item",
                        attrs: {
                          src: require("../../../assets/images/help_fill.png"),
                        },
                      }),
                      _c("p", [_vm._v("游戏规则")]),
                    ]
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("div", { staticClass: "main-content" }, [
        _c(
          "div",
          { staticClass: "mall-filter-con" },
          [
            _c("div", { staticClass: "input" }, [
              _c("form", { attrs: { action: "", "auto-complete": "off" } }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.assets_modal.search_name,
                      expression: "assets_modal.search_name",
                    },
                  ],
                  attrs: { type: "text", placeholder: "按名称搜索" },
                  domProps: { value: _vm.assets_modal.search_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.assets_modal,
                        "search_name",
                        $event.target.value
                      )
                    },
                  },
                }),
                _c("input", {
                  staticStyle: { height: "0", width: "0" },
                  attrs: { type: "text" },
                }),
              ]),
              _c("img", {
                attrs: {
                  src: require("@/assets/icons/interchange_search_icon.png"),
                  alt: "",
                },
              }),
            ]),
            _c(
              "Select",
              {
                on: {
                  "on-change": function ($event) {
                    return _vm.get_assets_list(
                      _vm.assets_modal.categoryId,
                      _vm.assets_modal.sort_price
                    )
                  },
                },
                model: {
                  value: _vm.price_range,
                  callback: function ($$v) {
                    _vm.price_range = $$v
                  },
                  expression: "price_range",
                },
              },
              [
                _c("Option", { attrs: { value: 0 } }, [_vm._v("不限")]),
                _c("Option", { attrs: { value: 1 } }, [_vm._v("0-50")]),
                _c("Option", { attrs: { value: 2 } }, [_vm._v("50-200")]),
                _c("Option", { attrs: { value: 3 } }, [_vm._v("200-1000")]),
                _c("Option", { attrs: { value: 4 } }, [_vm._v("1000-2000")]),
                _c("Option", { attrs: { value: 5 } }, [_vm._v("2000+")]),
              ],
              1
            ),
            _c(
              "div",
              {
                class: ["sort", _vm.assets_modal.sort_price ? "" : "active"],
                on: {
                  click: function ($event) {
                    return _vm.get_assets_list(
                      _vm.assets_modal.categoryId,
                      _vm.assets_modal.sort_price
                        ? (_vm.assets_modal.sort_price = 0)
                        : (_vm.sort_price = 1)
                    )
                  },
                },
              },
              [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.assets_modal.sort_price
                        ? "↓ 价格从低到高"
                        : "↑ 价格从高到低"
                    )
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "upgrade-items" }, [
          _c("div", { staticClass: "skins-columner" }, [
            _c(
              "div",
              { staticClass: "skins-columner__container" },
              _vm._l(_vm.active_assets_list, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "skins-columner__item-upgrade",
                    class: "rarity--" + item.rarity,
                    on: {
                      click: function ($event) {
                        return _vm.selected_assets(item, index)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "upgrade-contentItem" }, [
                      _c(
                        "div",
                        { staticClass: "upgrade-contentItem-top-item" },
                        [
                          _c("div", { staticClass: "skin-card__price" }, [
                            _vm._v(_vm._s(item.price)),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "upgrade-contentItem-middle-item flex flex-center-1",
                        },
                        [
                          _c("img", {
                            staticClass: "skin-card__img",
                            attrs: { src: _vm.$imgfilter(item.imgUrl) },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "upgrade-contentItem-bottom-item flex flex-end flex-jcsb",
                        },
                        [
                          _c("div", { staticClass: "bottomLeftItem" }, [
                            _c("p", [
                              _vm._v(
                                " " + _vm._s(_vm._f("GetItemName")(item.name))
                              ),
                            ]),
                            _c("p", { staticClass: "getItemSkinName-item" }, [
                              _vm._v(
                                _vm._s(_vm._f("GetItemSkinName")(item.name))
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "bottomRightItem" }, [
                            _c("p", { staticClass: "skin-card_quality" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("GetItemDuration")(item.name)) +
                                  " "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "skin-select flex flex-center-1",
                        class: {
                          "skin-selected": _vm.selectedItemIndex == index,
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "icon-plus",
                            style: {
                              display:
                                _vm.selectedItemIndex == index
                                  ? "none"
                                  : "inline-block",
                            },
                          },
                          [
                            _c("Icon", {
                              attrs: { type: "md-add", size: "30" },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "icon-checkmark",
                            style: {
                              display:
                                _vm.selectedItemIndex == index
                                  ? "inline-block"
                                  : "none",
                            },
                          },
                          [
                            _c("Icon", {
                              attrs: { type: "md-checkmark", size: "30" },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
        _c("div", { staticClass: "main-top-conItem flex flex-center-1" }, [
          _c("div", { staticClass: "main-top-con" }, [
            !_vm.$screen.mobile
              ? _c(
                  "div",
                  { staticClass: "item-con-1 flex flex-col flex-center-1" },
                  [
                    _c("c-svg", {
                      staticClass: "item-box",
                      attrs: { src: "upgrade-item.svg" },
                    }),
                    _c("div", { staticClass: "item-name" }, [
                      _vm._v("随机饰品"),
                    ]),
                    _c("div", { staticClass: "name-desc" }, [
                      _vm._v("失败获得一件随机饰品"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "flex flex-center-1" },
              [
                _c("c-turntable", {
                  ref: "turntable",
                  attrs: {
                    upgrade_success_rate: _vm.upgrade_success_rate,
                    minRollNum: _vm.minRollNum,
                    maxRollNum: _vm.maxRollNum,
                    roll: _vm.roll,
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "mobile-style" }, [
              _vm.$screen.mobile
                ? _c(
                    "div",
                    { staticClass: "item-con-1 flex flex-col flex-center-1" },
                    [
                      _c("c-svg", {
                        staticClass: "item-box",
                        attrs: { src: "upgrade-item.svg" },
                      }),
                      _c("div", { staticClass: "item-name" }, [
                        _vm._v("随机饰品"),
                      ]),
                      _c("div", { staticClass: "name-desc" }, [
                        _vm._v("失败获得一件随机饰品"),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.targetData.price == 0
                ? _c(
                    "div",
                    { staticClass: "item-con-1 flex flex-col flex-center-1" },
                    [
                      _c("c-svg", {
                        staticClass: "item-box",
                        attrs: { src: "upgrade-item.svg" },
                      }),
                      _c("div", { staticClass: "item-name" }),
                      _c("div", { staticClass: "name-desc" }, [
                        _vm._v("请从上方选择一件饰品"),
                      ]),
                    ],
                    1
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "item-con flex flex-col flex-center-1 active",
                      class: "rarity" + _vm.targetData.rarity,
                    },
                    [
                      _c("div", { staticClass: "item-name-con" }, [
                        _c("div", [
                          _c("div", { staticClass: "weapon-name" }, [
                            _vm._v(
                              _vm._s(_vm._f("GetItemName")(_vm.targetData.name))
                            ),
                          ]),
                          _c("div", { staticClass: "skin-name" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("GetItemSkinName")(_vm.targetData.name)
                              )
                            ),
                          ]),
                        ]),
                        _c("div", [
                          _c("div", { staticClass: "dur" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("GetItemDuration")(_vm.targetData.name)
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _c("div", { staticClass: "item-pic-con" }, [
                        _vm.targetData.imgUrl
                          ? _c("img", {
                              staticClass: "active",
                              attrs: {
                                src: _vm._f("imgfilter")(_vm.targetData.imgUrl),
                              },
                            })
                          : _vm._e(),
                      ]),
                      _c("c-svg", {
                        staticClass: "item-bg",
                        attrs: { src: "itembg.svg", fill: "rgb(0, 0, 0,.2)" },
                      }),
                      _c("div", { staticClass: "item-price" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("物品价值："),
                        ]),
                        _c(
                          "div",
                          { staticClass: "price" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("conversion")(_vm.targetData.price)
                                ) +
                                " "
                            ),
                            _c("c-svg", {
                              attrs: {
                                src: "bill.svg",
                                width: "12",
                                height: "12",
                                fill: "#4762f2",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "main-bottom-conItem flex flex-col flex-center-1" },
          [
            _c("div", { staticClass: "main-bottom-center-item" }, [
              _c(
                "button",
                {
                  staticClass: "flex flex-center-1",
                  attrs: { disabled: _vm.isLotterying },
                  on: {
                    click: function () {
                      return _vm.send_trade_api()
                    },
                  },
                },
                [
                  _vm._v(" 确定升级"),
                  _c("span", { staticStyle: { "margin-left": "5px" } }, [
                    _vm._v(
                      _vm._s(_vm.totalPrice) +
                        " + " +
                        _vm._s(_vm.upgradeFeePrice) +
                        "手续费"
                    ),
                  ]),
                ]
              ),
              _c("div", { staticClass: "main-bottom-center-item-item" }, [
                _c("div", { staticClass: "left" }, [
                  _c("div", { staticClass: "info-con flex flex-center-2" }, [
                    _vm._v(" 欧皇概率 "),
                    _c(
                      "div",
                      { staticClass: "info-con-item" },
                      _vm._l([1, 5, 10, 50], function (probability) {
                        return _c(
                          "span",
                          {
                            key: probability,
                            class: [
                              { "active-prob": _vm.curProb === probability },
                              "popular-prob",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.selProb(probability)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(probability) + "% ")]
                        )
                      }),
                      0
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "mobile-left-con-mobile flex flex-center-2" },
                  [
                    _c("div", { staticClass: "mobile-left-con-mobile-item" }, [
                      _c("p", [_vm._v("使用余额")]),
                      _c("div", { staticClass: "input-box" }, [
                        _c("input", {
                          attrs: { type: "number", readonly: "" },
                          domProps: { value: _vm.totalPrice },
                          on: {
                            blur: function ($event) {
                              return _vm.onUseBalanceInputChange($event)
                            },
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "mobile-left-con-mobile-item" }, [
                      _c("p", [_vm._v("ROLL中奖下限")]),
                      _c("div", { staticClass: "input-box" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.minRollNum,
                              expression: "minRollNum",
                            },
                          ],
                          attrs: { type: "number" },
                          domProps: { value: _vm.minRollNum },
                          on: {
                            blur: _vm.minRollNumHandler,
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.minRollNum = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]),
                    _c("div", { staticClass: "mobile-left-con-mobile-item" }, [
                      _c("p", [_vm._v("ROLL中奖上限")]),
                      _c("div", { staticClass: "input-box" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.maxRollNum,
                              expression: "maxRollNum",
                            },
                          ],
                          attrs: { type: "number" },
                          domProps: { value: _vm.maxRollNum },
                          on: {
                            blur: _vm.maxRollNumHandler,
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.maxRollNum = $event.target.value
                            },
                          },
                        }),
                      ]),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        false
          ? _c(
              "div",
              {
                staticClass: "main-bottom-conItem flex flex-col flex-center-1",
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "main-bottom-con flex flex-center-1 flex-ais",
                  },
                  [
                    _vm.$screen.mobile
                      ? _c("div", { staticClass: "main-bottom-center-con" }, [
                          _c(
                            "button",
                            {
                              staticClass: "flex flex-center-1",
                              attrs: { disabled: _vm.isLotterying },
                              on: {
                                click: function () {
                                  return _vm.send_trade_api()
                                },
                              },
                            },
                            [
                              _vm._v(" 确定升级"),
                              _c(
                                "span",
                                { staticStyle: { "margin-left": "5px" } },
                                [_vm._v(_vm._s(_vm.totalPrice))]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "left-con" },
                      [
                        _c("div", { staticClass: "left" }, [
                          _c(
                            "div",
                            { staticClass: "info-con flex flex-center-2" },
                            [
                              _vm._v(" 欧皇概率 "),
                              _c(
                                "div",
                                { staticClass: "info-con-item" },
                                _vm._l([1, 5, 10, 50], function (probability) {
                                  return _c(
                                    "span",
                                    {
                                      key: probability,
                                      class: [
                                        {
                                          "active-prob":
                                            _vm.curProb === probability,
                                        },
                                        "popular-prob",
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.selProb(probability)
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(probability) + "% ")]
                                  )
                                }),
                                0
                              ),
                            ]
                          ),
                        ]),
                        !_vm.$screen.mobile
                          ? [
                              _c("div", { staticClass: "left" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "info-con flex flex-center-2",
                                  },
                                  [
                                    _vm._v(" 使用余额 "),
                                    _c("div", { staticClass: "input-box" }, [
                                      _c("input", {
                                        attrs: { type: "number", readonly: "" },
                                        domProps: { value: _vm.totalPrice },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.onUseBalanceInputChange(
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "left" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "info-con flex flex-center-2 flex-ais",
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "info-con-text flex flex-center-1",
                                      },
                                      [_vm._v("ROLL中奖下限")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-col flex-center-1",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-box" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.minRollNum,
                                                  expression: "minRollNum",
                                                },
                                              ],
                                              attrs: { type: "number" },
                                              domProps: {
                                                value: _vm.minRollNum,
                                              },
                                              on: {
                                                blur: _vm.minRollNumHandler,
                                                input: function ($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.minRollNum =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "roll-qujian-block-item",
                                          },
                                          [_vm._v("|")]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "left" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "info-con flex flex-center-2 flex-ais",
                                    staticStyle: {
                                      "margin-top": "0 !important",
                                    },
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "info-con-text flex flex-center-1",
                                      },
                                      [_vm._v("ROLL中奖上限")]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "flex flex-col flex-center-1",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "input-box" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.maxRollNum,
                                                  expression: "maxRollNum",
                                                },
                                              ],
                                              attrs: { type: "number" },
                                              domProps: {
                                                value: _vm.maxRollNum,
                                              },
                                              on: {
                                                blur: _vm.maxRollNumHandler,
                                                input: function ($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.maxRollNum =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          : _vm._e(),
                        _vm.$screen.mobile
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "mobile-left-con-mobile flex flex-center-2",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "mobile-left-con-mobile-item",
                                  },
                                  [
                                    _c("p", [_vm._v("使用余额")]),
                                    _c("div", { staticClass: "input-box" }, [
                                      _c("input", {
                                        attrs: { type: "number", readonly: "" },
                                        domProps: { value: _vm.totalPrice },
                                        on: {
                                          blur: function ($event) {
                                            return _vm.onUseBalanceInputChange(
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "mobile-left-con-mobile-item",
                                  },
                                  [
                                    _c("p", [_vm._v("ROLL中奖下限")]),
                                    _c("div", { staticClass: "input-box" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.minRollNum,
                                            expression: "minRollNum",
                                          },
                                        ],
                                        attrs: { type: "number" },
                                        domProps: { value: _vm.minRollNum },
                                        on: {
                                          blur: _vm.minRollNumHandler,
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.minRollNum = $event.target.value
                                          },
                                        },
                                      }),
                                    ]),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "mobile-left-con-mobile-item",
                                  },
                                  [
                                    _c("p", [_vm._v("ROLL中奖上限")]),
                                    _c("div", { staticClass: "input-box" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.maxRollNum,
                                            expression: "maxRollNum",
                                          },
                                        ],
                                        attrs: { type: "number" },
                                        domProps: { value: _vm.maxRollNum },
                                        on: {
                                          blur: _vm.maxRollNumHandler,
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.maxRollNum = $event.target.value
                                          },
                                        },
                                      }),
                                    ]),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                    !_vm.$screen.mobile
                      ? _c("div", { staticClass: "main-bottom-center-con" }, [
                          _c(
                            "button",
                            {
                              staticClass: "flex flex-col flex-center-1",
                              attrs: { disabled: _vm.isLotterying },
                              on: {
                                click: function () {
                                  return _vm.send_trade_api()
                                },
                              },
                            },
                            [
                              _vm._v(" 确定升级"),
                              _c("span", [_vm._v(_vm._s(_vm.totalPrice))]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "right-con" }),
                  ]
                ),
              ]
            )
          : _vm._e(),
        _vm.itemHistory.data && _vm.itemHistory.data.length > 0
          ? _c(
              "div",
              { staticClass: "main-history-item flex flex-col flex-center-1" },
              [
                _c("div", { staticClass: "history-item" }, [
                  _c("h2", { staticClass: "history-title" }, [
                    _vm._v("最近掉落"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "history-box" },
                    _vm._l(_vm.itemHistory.data, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "history-box-item" },
                        [
                          _c("c-award", {
                            attrs: {
                              rarity: item.item.rarity,
                              picture: item.item.itemPic,
                              rate: item.rate,
                              name: item.item.name,
                              price: item.item.sellPrice,
                              width: "100%",
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _c("c-RewardModal", { ref: "upgrade_reward_ui" }),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal notice-modal",
            "footer-hide": "",
            width: "'438rem'",
            closable: false,
          },
          model: {
            value: _vm.notice_modal_show,
            callback: function ($$v) {
              _vm.notice_modal_show = $$v
            },
            expression: "notice_modal_show",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "欧皇升级玩法说明", has_close_button: "" },
              on: {
                close_button_click: function () {
                  _vm.notice_modal_show = false
                },
              },
            },
            [
              _c("div", { staticClass: "text-content" }, [
                _c("p", [
                  _vm._v(
                    " 1、您会随机获得一件饰品，或有机会获得一件心仪的饰品。※总成功率不得低于 1%。 "
                  ),
                ]),
                _c("p", [
                  _vm._v(
                    " 2、每次成功概率为相互独立的，例如 50% 的成功概率升级 2 次，但不代表有 100% 的机会。 "
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.prize.animate,
              expression: "prize.animate",
            },
          ],
          staticClass: "case-animation-modal",
        },
        [
          _c("c-animation", {
            ref: "runbox",
            on: { on_finished: _vm.endCallBack },
          }),
        ],
        1
      ),
      _vm.prize.animate ? _c("div", { staticClass: "shadow_box" }) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }